import React from 'react'

export default function Phase() {
    return (
        <>
            <section className="rewards_faq pt-120 pb-120 position-relative">
                <div className="container">
                    <div className="row align-items-center justify-content-center gy-8">
                        <div className="col-xl-5">
                            <div className="rewards_faq__content">
                                <h2 className="mb-5 mb-md-6 wow fadeInUp">ARMA Coin Presale</h2>
                                <p className="roboto mb-8 mb-md-10 wow fadeInUp">ARMA presale is divided into five phases & each phase has a different price, ranging from $1.50 to $2.50 per coin. The primary four phases are allocated 1.2 million (12 Lac) ARMA coins while the fifth phase is allocated with remaining 910,500 ARMA coins. Users can purchase ARMA coin using USDT or Aarma tokens (BSC).</p>
                            </div>
                        </div>
                        <div className="col-xl-7">
                            <div className="rewards_faq__thumb">
                                <img src="assets/images/aarma_coin_presale.png" className="max-un leftright-animation w-100" alt="Images" />
                            </div>
                        </div>
                    </div>
                </div>
                {/* <img class="rewards_faq__light position-absolute top-0 start-0" src="assets/images/light-faq.png" alt="Icon"> */}
            </section>
        </>
    )
}
